import {Component, OnInit, Type} from '@angular/core';
import {Http, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {Subscription} from 'rxjs/Subscription';
import {ConfigService} from '../../services/config.service';
import {LicenseService} from '../../services/license.service';
import {NotificationService} from '../../services/notification.service';
import {Router, ActivatedRoute} from '@angular/router';
import {LoadingPage} from '../../../shared/components/loading/loading.page.component';
import {ProfileService} from '../profile/profile.service';
import {SimpleAlertComponent} from '../../../shared/components/modal/simple-alert.component';
import {ModalService} from '../../services/modal.service';
import {ModalSize, SmartModalService} from '../../services/smart-modal.service';
import {CertificateService} from '../content/certificate/certificate.service';
import {SimpleInfoComponent} from '../../../shared/components/modal/simple-info.component';
import {Subject} from 'rxjs/Subject';
import {ContentUpdatedInfoComponent} from '../../../shared/components/modal/content-updated-info.component';

@Component({
  selector: 'itpx-deliverables',
  templateUrl: './deliverables.component.html',
  styleUrls: ['./deliverables.component.css']
})
export class DeliverablesComponent extends LoadingPage implements OnInit {

  private sub: Subscription;
  private deliverables: Array<any>;
  private certificates: Array<any>;
  private errorMessage: String;
  private openModal = new Subject<any>();
  private updateContent = new Subject<any>();
  private update = new Subject<any>();
  profile: any;


  constructor(private licenseService: LicenseService,
              private notificationService: NotificationService,
              private route: ActivatedRoute,
              private router: Router,
              private profileService: ProfileService,
              private certificateService: CertificateService,
              private modalService: SmartModalService
  ) {
    super();
  }

  ngOnInit() {

    this.update.subscribe(assignmentId => {
      Observable.zip(this.profileService.getProfile(), this.licenseService.getDeliverables(assignmentId), this.licenseService.verifyContentChange(assignmentId))
        .subscribe(([profile, deliverables, contentChange]) => {
          this.profile = profile.data;
          this.loadAssignments(deliverables, assignmentId);
          this.checkContentUpdate(contentChange, assignmentId);
        }, error => {
          this.errorMessage = null;
          this.error();
        });
    });

    this.openModal.subscribe(data => this.modalService.open(<Type<Component>>ContentUpdatedInfoComponent, {
      text: 'brandedPortal.deliverable.updated.confirm',
      text2: 'brandedPortal.deliverable.updated.confirm2',
      html: true,
      table: data.changedContents,
    }, 'Content updated', ModalSize.Md)
      .bindToLifecycle(this)
      .map(r => r.result)
      .subscribe(
        v => {
          if (v.length > 0) {
            this.loading();
            this.updateContent.next({assignmentId: data.assignmentId, contents: v});
          }
        }, err => {
          this.ready();
        }
      ));

    this.updateContent.subscribe(result => {
      this.licenseService.updateContent(result.assignmentId, result.contents)
        .subscribe(_ => this.update.next(result.assignmentId), err => this.error());
    });

    this.sub = this.route.params.subscribe(params => {
      let assignmentId = params['assignmentId'];
      this.update.next(assignmentId);
    });
  }

  private loadAssignments(deliverables: any, assignmentId: any) {
    if (deliverables['data'] && Array.isArray(deliverables.data) && deliverables.data.length > 0) {
      this.deliverables = deliverables['data'].map(d => {
        d.assignmentId = assignmentId;
        d.disabled = !d.enabled;
        return d;
      });
      this.certificateService.getElearningCertificates(assignmentId).subscribe(certificates => this.certificates = certificates.data);
      this.ready();
    } else {
      this.errorMessage = null;
      this.error();
    }
  }

  private checkContentUpdate(content: any, assignmentId: any) {
    if (content.data && content.data.length > 0) {
      this.openModal.next({assignmentId: assignmentId, changedContents: content.data});
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/deliverable/deliverables.component.ts